
// promoteDataList 推广下的页面的 列表， 参数是路由url 字段名 reportname
// promoteDataUpload 推广导入 ，参数是路由url 字段名 reportname
// promoteDataExport 推广导出 ，参数是路由url 字段名 reportname
// 导入文件头信息 接口 get  /excelheaderTuiguang/{reportname} 路由url拼接
export const module_api = {
  promote: {
    list: {
      url: 'promoteDataList',
      method: "post",
      title: '列表'
    },
    export: {
      url: 'promoteDataDownload',
      method: "post",
      title: '导出'
    },
    upload: {
      url: 'promoteDataUpload',
      method: "post",
      title: '导入'
    },
    fileHeader: {
      url: 'excelheader',
      method: 'get',
      title: '导入文件的头信息'
    }
  },
  member: {
    upload: {
      url: 'memberListUpload',
      method: "post",
      title: '导入'
    },
    fileHeader: {
      url: 'excelheader',
      method: "get",
      title: '导入头文件信息'
    }
  },
  // 4.21 添加
  maijia: {
    list: {
      url: 'maijiawangLists',
      method: "post",
      title: '列表'
    },
    export: {
      url: 'maijiawangDownload',
      method: "post",
      title: '导出'
    },
    upload: {
      url: 'maijiawangUpload',
      method: "post",
      title: '导入'
    },
    fileHeader: {
      url: 'excelheader',
      method: 'get',
      title: '导入文件的头信息'
    }
  },
  canmou: {
    list: {
      url: 'canmouDataList',
      method: "post",
      title: '列表'
    },
    export: {
      url: 'canmouDataDownload',
      method: "post",
      title: '导出'
    },
    upload: {
      url: 'canmouDataUpload',
      method: "post",
      title: '导入'
    },
    fileHeader: {
      url: 'excelheader',
      // url: '',
      method: 'get',
      title: '导入文件的头信息'
    }
  },
  // 会员页面在 base 下
  base: {
    fileHeader: {
      url: 'excelheader',
      method: "get",
      title: '导入头文件信息'
    }
  }

}

// ~基础数据里，会员的6个页面，上传的接口统一一下：memberDataUpload


// WEBPACK FOOTER //
// ./src/common/config.js